'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _when = require('when');

var _when2 = _interopRequireDefault(_when);

var _sequence = require('when/sequence');

var _sequence2 = _interopRequireDefault(_sequence);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchInitialDataForComponent(component) {
  return component.fetchInitialData || component.WrappedComponent && component.WrappedComponent.fetchInitialData;
}

function filterForApiDependentRoutes(routes) {
  return routes.filter(function (route) {
    return route.component && fetchInitialDataForComponent(route.component);
  });
}

function fetchDataForCurrentRoute(state, store, apiClient) {
  var apiDependentRoutes = filterForApiDependentRoutes(state.routes);
  var fetchTasks = apiDependentRoutes.map(function (route) {
    return function () {
      return _when2.default.all(fetchInitialDataForComponent(route.component).apply(undefined, arguments));
    };
  });
  return (0, _sequence2.default)(fetchTasks, state.params, state.location.query, store, apiClient);
}

exports.default = {
  filterForApiDependentRoutes: filterForApiDependentRoutes,
  fetchDataForCurrentRoute: fetchDataForCurrentRoute
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/utils-routing/lib/index.js
// module id = 1567
// module chunks = 1